import { Logger } from '~/core';
import { useSettingsStore } from '~/stores';
import RequestService from './request';

class SettingsService {
    initializeSettings() {
        // TODO: consider data injected from backend
        return RequestService.get('/settings')
            .then((data) => {
                Logger.debug('Settings', 'Fetched instance settings', data);

                const settingsStore = useSettingsStore();
                settingsStore.setSettings(data);
            })
            .finally(() => {
                const settingsStore = useSettingsStore();
                settingsStore.markInitialized();
            });
    }
}

export default new SettingsService();
